
<template>
  <v-container class="container">
    <div>
      <h3>
        <v-icon class="mt-n1 mr-1" style="font-size: 35px"
          >mdi-file-excel</v-icon
        >Carga CSV Vocales
      </h3>
      <h6 class="mt-n2 ml-10">Carga masiva de Vocales a través de CSV</h6>
    </div>
    <v-card class="mt-10">
      <v-card-text>

        <v-row class="mt-5">
          <p class="ml-8 subtitle">Descargar un Ejemplo de carga <a href="/files/FormatoPagosVocales.csv" download>Pinchando Aquí</a>, Puede encontrar el de los campos<a href="/files/glosario_pago_vocal.xlsx" download>Pinchando Aquí.</a> </p>
        </v-row>
        <v-row>
          <v-file-input
            v-model="file"
            label="Seleccionar archivo"
            outlined
            dense
            :rules="fileRules"
            accept=".csv"
            @change="onFileChange"
          ></v-file-input>
        </v-row>
        <v-row>
          <v-btn @click="readCsv" :disabled="!isFileValid" >Cargar Datos</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Papa from 'papaparse';
import axios from 'axios'
import { PagoVocalesService } from "../../util/Api/PagoVocales/calls";
import { mapGetters } from "vuex";
import { Loading } from "element-ui";
import Swal from "sweetalert2";

export default {
  name: "IngresoPagoComponents",
  components: {},
  data() {
    return {
      file: null,
      jsonData: null,
      isFileValid: false,
      loadingInstance: null,
      fileRules: [
        (v) => !!v || 'Debe seleccionar un archivo'
      ]
    }
  },
  computed: {
    ...mapGetters(["getPerfil"])
  },

  methods: {
    onFileChange(file) {
      // Reinicia validaciones cada vez que cambia el archivo
      this.jsonData = null;
      this.isFileValid = false;

      if (!file) return;

      // Verificar que el archivo tenga extensión .csv
      if (!file.name.toLowerCase().endsWith('.csv')) {
        Swal.fire({ type: "error", html: "El archivo debe tener formato CSV (.csv)"});
        this.file = null;
        return;
      }

      // Mostrar mensaje de que se está procesando el archivo
      const loadingValidation = Loading.service({
        fullscreen: true,
        text: "Validando estructura del archivo CSV...",
        background: "rgba(0, 0, 0, 0.8)"
      });

      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;

        // Validar que el separador detectado sea coma
        const delimiterCheck = Papa.parse(data, { preview: 1, delimiter: "" });
        const detectedDelimiter = delimiterCheck && delimiterCheck.meta ? delimiterCheck.meta.delimiter : null;
        if (detectedDelimiter && detectedDelimiter !== ",") {
          loadingValidation.close();
          this.file = null;
          Swal.fire({
            type: "error",
            html: `El archivo CSV debe usar coma (,) como separador. Se detectó "${detectedDelimiter}".`
          });
          return;
        }

        // Parsear el CSV usando PapaParse
        const parsedData = Papa.parse(data, {
          header: true,
          skipEmptyLines: true,
          delimiter: ","
        });
        this.jsonData = parsedData.data;

        // Definir los campos requeridos según los encabezados del CSV
        const requiredFields = [
          'conceptopago','nombreeleccion','fechaeleccion','rut','dv','apellidopaterno','apellidomaterno',
          'nombre','correo','calle','tipocalle','dirnumero','bancopagosbif','tipocuentapago',
          'numerocuentapago','montopago','monedapago','codigoregistro','codigomesa','urldocumento',
          'DVcodigoregistro', 'nombreComuna', 'numeroRegion', 'tipoEleccion', 'fechaCapacitacion', 'identificacionLocal',
          'codigoCircunscripcion', 'circunscripcionElectoral'
        ];

        let valid = true;
        // Verificamos solo que estén presentes las cabeceras requeridas
        if (this.jsonData.length > 0) {
          const firstRow = this.jsonData[0];
          const missingFields = requiredFields.filter(field => !Object.prototype.hasOwnProperty.call(firstRow, field));

          if (missingFields.length > 0) {
            valid = false;
            Swal.fire({
              type: "error",
              html: `El archivo CSV no contiene las siguientes cabeceras requeridas:<br><b>${missingFields.join(', ')}</b>`
            });
          }

        } else {
          valid = false;
          Swal.fire({
            type: "error",
            html: "El archivo CSV no contiene datos"
          });
        }

        this.isFileValid = valid && this.fileRules.every(rule => rule(this.file) === true);

        // Cerrar el indicador de carga de validación
        loadingValidation.close();
      };

      reader.readAsText(file);
    },

    async readCsv() {
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Iniciando carga...",
          background: "rgba(0, 0, 0, 0.8)"
        });

        if (!this.file) return;

        // Se asume que la validación ya se realizó en onFileChange, por lo que si llega hasta aquí
        // el archivo ya es válido.
        const body = {
          filename: this.file.name,
          filetype: 'text/csv',
        };

        // Obtener URL para subir archivo
        this.loadingInstance.setText("Obteniendo acceso al servidor...");
        const resp = await PagoVocalesService.chargeFile(body);
        console.log("resp", resp);

        // Verificar respuesta del servicio
        if (!resp || (resp.statusCode !== 200 && resp.statusCode !== 201)) {
          throw new Error(resp && resp.msg ? JSON.stringify(resp.msg) : 'Error en la respuesta del servidor');
        }

        // Verificar la estructura de la respuesta y extraer la URL
        let uploadURL = null;
        if (resp.body) {
          try {
            // Si body es un string JSON, parsearlo
            const bodyData = typeof resp.body === 'string' ? JSON.parse(resp.body) : resp.body;
            uploadURL = bodyData.uploadURL;
          } catch (e) {
            console.error('Error al parsear la respuesta:', e);
          }
        } else if (resp.url) {
          uploadURL = resp.url;
        }

        if (!uploadURL) {
          throw new Error('La URL para la carga no fue proporcionada por el servidor');
        }

        // Carga a S3 usando axios y la URL temporal proporcionada
        this.loadingInstance.setText("Subiendo archivo a servidor, por favor espere...");
        await axios.put(uploadURL, this.file, {
          headers: {
            'Content-Type': 'text/csv'
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            this.loadingInstance.setText(`Subiendo archivo: ${percentCompleted}% completado`);
          }
        });
        this.file=null
        if (this.loadingInstance) {
          this.loadingInstance.close();
        }
        Swal.fire({ type: "success", html: `Pagos Cargados` });
      } catch (error) {
        console.log("error", error);
        if (this.loadingInstance) {
          this.loadingInstance.close();
        }
        // Mejorar mensaje de error para el usuario
        const mensajeError = error.message || 'Error desconocido';
        Swal.fire({
          type: "error",
          html: `Error al Cargar Documento: ${mensajeError}`
        });
      }
    }
  },
};
</script>

<style scoped>
.container {
  text-align: start !important;
}
</style>
